import { ShoppingBag } from "lucide-react";
import { PAYMENT_URL, trackOrderClickQuietly } from "@/lib/order";
import { cn } from "@/lib/utils";

export default function OrderNowLink({ source, className = "", children = "Order Now", showIcon = false, onClick, ...props }) {
  const handleClick = (event) => {
    if (typeof onClick === "function") onClick(event);
    trackOrderClickQuietly(source);
  };

  return (
    <a href={PAYMENT_URL} target="_blank" rel="noreferrer" onClick={handleClick} className={cn(className)} {...props}>
      {showIcon && <ShoppingBag size={18} />}
      {children}
    </a>
  );
}
